import { Grid } from "@material-ui/core";
import {
	InputOptionMaster,
	InputTextMaster,
	LabelRequired,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import {
	selectAlamatLokasi,
	useCity,
	useDistrict,
	useSubDistrict,
} from "../helpers";
import { TYPE_INSTANCE2 } from "App/constants";
import { useCity2, useDistrict2, useProvinsi2, useSubDistrict2 } from "App/Component/layout/Registrasi/ProfileRekamMedis/ui";

export default function LokasiAlamatForm({
	formDataAlamat,
	setFormDataAlamat,
}) {
	const listProv = useSelectOption(
		true,
		"/alamat/list_propinsi_prm",
		TYPE_INSTANCE2
	);

	const handleChange = (text) => (e) => {
		setFormDataAlamat({
			...formDataAlamat,
			[text]: e.target.value,
		});
	};

	return (
		<>
			<form
				onSubmit={(e) => console.log("No Method")}
				style={{
					display: formDataAlamat.available === false ? "none" : "",
				}}
			>
				<div className="mb-1">
					<Grid container spacing={1}>
						<Grid item md={3}>
							<InputOptionMaster
								name="type"
								label={<LabelRequired label="Kategori Alamat Lokasi" />}
								id="type"
								withSearch={false}
								data={selectAlamatLokasi}
								value={formDataAlamat.type}
								needParse={false}
								onChange={handleChange("type")}
							/>
						</Grid>
						<Grid item md={3}>
							<InputOptionMaster
								name="provinsi"
								label={<LabelRequired label="Provinsi" />}
								id="provinsi"
								value={formDataAlamat.province}
								withSearch={true}
								labelValue={formDataAlamat.province_name}
								onChange={(e) => {
									setFormDataAlamat({
										...formDataAlamat,
										province: e?.value,
										province_name: e?.label,
										city: null,
										city_name: "Pilih Kota",
										district: null,
										district_name: "Pilih Kecamatan",
										sub_district: null,
										sub_district_name: "Pilih Kelurahan",
									});
								}}
								data={useProvinsi2(62)}
							/>
						</Grid>
						<Grid item md={3}>
							<InputOptionMaster
								name="kota"
								label={<LabelRequired label="Kota" />}
								id="kota"
								needParse={false}
								value={formDataAlamat.city}
								withSearch={true}
								labelValue={formDataAlamat.city_name}
								onChange={(e) => {
									setFormDataAlamat({
										...formDataAlamat,
										city: e?.value,
										city_name: e?.label,
										district: null,
										district_name: "Pilih Kecamatan",
										sub_district: null,
										sub_district_name: "Pilih Kelurahan",
									});
								}}
								data={useCity2(formDataAlamat.province)}
							/>
						</Grid>
						<Grid item md={3}>
							<InputOptionMaster
								name="dictrict"
								label={<LabelRequired label="Kecamatan" />}
								id="dictrict"
								needParse={false}
								value={formDataAlamat.district}
								withSearch={true}
								labelValue={formDataAlamat.district_name}
								onChange={(e) => {
									setFormDataAlamat({
										...formDataAlamat,
										district: e?.value,
										district_name: e?.label,
										sub_district: null,
										sub_district_name: "Pilih Kelurahan",
									});
								}}
								data={useDistrict2(formDataAlamat.city)}
							/>
						</Grid>
						<Grid item md={3}>
							<InputOptionMaster
								name="sub_district"
								label={<LabelRequired label="Kelurahan" />}
								id="sub_district"
								needParse={false}
								value={formDataAlamat.sub_district}
								withSearch={true}
								labelValue={formDataAlamat.sub_district_name}
								onChange={(e) => {
									setFormDataAlamat({
										...formDataAlamat,
										sub_district: e?.value,
										sub_district_name: e?.label,
									});
								}}
								data={useSubDistrict2(formDataAlamat.district)}
							/>
						</Grid>
						<Grid item md={3}>
							<InputTextMaster
								name="line"
								label={<LabelRequired label="Alamat Lengkap" />}
								id="line"
								placeholder="Alamat Lengkap"
								value={formDataAlamat.line}
								onChange={handleChange("line")}
							/>
						</Grid>
						<Grid item md={3}>
							<InputTextMaster
								name="postalCode"
								label={<LabelRequired label="Kode POS" />}
								id="postalCode"
								placeholder="Kode POS"
								value={formDataAlamat.postalCode}
								onChange={handleChange("postalCode")}
							/>
						</Grid>
					</Grid>
				</div>
			</form>
		</>
	);
}
